import styles from './FlexibleForm.module.css'
import { Input } from "shared/ui/strspykit/Input"
import { Controller, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import * as z from 'zod'
import { useAutoSubmit } from 'shared/hooks/useAutoSubmit'
import { useEffect } from 'react'

interface FlexibleFormProps{
    value: any,
    onSubmit: (value: any, event: any) => void
    isLoading?: boolean
}

const formSchema = z.object({
    daysAhead: z
        .number()
}).passthrough()

type FormData = z.infer<typeof formSchema>

export const FlexibleForm = (props: FlexibleFormProps): JSX.Element => {
    const {
        value,
        onSubmit,
        isLoading = false
    } = props

    const form = useForm<FormData>({
        resolver: zodResolver(formSchema),
        mode: 'onChange',
        defaultValues: {
            daysAhead: 3
        },
        values: value
    })

    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue,
        watch,
        formState: { errors, isDirty, isValid },
    } = form

    const handleFormSubmit = (submitValue: any, event: any) => {
        onSubmit?.(submitValue, event)
    }  

    const handleAutoSubmit = (event: any) => {
        onSubmit?.(event, event)
    }

    useAutoSubmit(form, handleAutoSubmit, 0)

    return (
        <form
            onSubmit={handleSubmit(handleFormSubmit)}
            
        >
            <div className={styles.FlexibleForm__EmailContainer}>
                <Controller
                    name="daysAhead"
                    control={control}
                    render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState: { dirtyFields },
                    }) => (
                        <div className={styles.FlexibleForm__FormControl}>
                            <label 
                                className={styles.FlexibleForm__FormLabel}
                                htmlFor={name}
                            >
                                Days Ahead
                            </label>
                            <Input
                                value={value.toString()}
                                name={name}                
                                onValueChange={
                                    (event) => {                          
                                        onChange(parseInt(event.target.value))
                                    }
                                }
                                type={'number'}
                                options={
                                    {
                                        min:"1",
                                        max:"31" 
                                    }
                                }
                            />
                        </div>
                    )}
                />
            </div>
            <div className={styles.FlexibleForm__ActionsContainer}>
  
            </div>    
        </form>      
    )
}